import React, {Component} from "react";
import DateText from "../../../common/DateText/DateText"
import "./AccountHeader.css";
import EditField from "../../../common/EditField/EditField";
import Permissions from "../../../authentication/Permissions";
import AuthorizationService from "../../../services/authorization-service";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import AccountContact from "../../components/AccountContact";

class AccountHeader extends Component {


  constructor(props, context) {
    super(props, context);
    this.state = {
      isEditContactVisible: false
    }
  }

  setInternal = (value) => {
    const account = {...this.props.account};
    account.isInternal = value.checked;
    this.props.updateAccount(account);
  }

  allowedHosts = () => {
    if (!this.props.account.attributes) return "";
    let result = this.props.account.attributes.find(a => a.name === "allowed-hosts");
    if (result) return result.value;
    return "";
  }


  handleContactChange = contact => {
    let updated = {...this.props.account}
    updated.contact = contact
    this.setState({
      isEditContactVisible: false
    })
    this.props.updateAccount(updated)
  }

  render() {
    return (
        <div className="account-header">
          <div className="row">
            <div className="col-md-6">
              <div className="row details-row">
                <div className="col-md-3 details-label">Customer id</div>
                <div className="col-md-9">{this.props.account.customerId}</div>
              </div>
              {this.props.account.apigeeCompanyName &&
              <div className="row details-row">
                <div className="col-md-3 details-label">Company name</div>
                <div className="col-md-9">{this.props.account.apigeeCompanyName}</div>
              </div>
              }
              <div className="row details-row">
                <div className="col-md-3 details-label">Internal Acct</div>
                <EditField
                    value={this.props.account.isInternal ? this.props.account.isInternal : false}
                    label={this.props.account.isInternal && this.props.account.isInternal ? "Yes" : "No"}
                    editHandler={this.setInternal}
                    header="Internal? Check for yes, uncheck for no."
                    title="Set the Internal Flag for the Account"
                    type="checkbox"
                    canEdit={AuthorizationService.hasPermission(Permissions.account.isInternal.edit) && this.props.account.isActive}
                />
              </div>
              <div className="row details-row">
                <div className="col-md-3 details-label">Allowed Hosts</div>
                <div className="col-md-9">{this.allowedHosts()}</div>
              </div>
              <div className="row details-row">
                <div className="col-md-3 details-label">Contact</div>
                <div
                    className="col-md-9">{this.props.account.contact ? this.props.account.contact.firstName + " " + this.props.account.contact.lastName + " (" + this.props.account.contact.email + ")" : ""}
                  &nbsp;<FontAwesomeIcon
                      className="edit edit-icon"
                      icon="edit"
                      size="sm"
                      title="Edit contact information for account"
                      color="#62BB46"
                      onClick={() => this.setState({
                        isEditContactVisible: true
                      })}
                  /></div>
              </div>

            </div>
            <div className="col-md-6">
              <div className="row details-row">
                <div className="col-md-5 details-label">Created</div>
                <div className="col-md-7">
                  <DateText date={this.props.account.createdAt}/>
                </div>
              </div>
              <div className="row details-row">
              <div className="col-md-5 details-label">Updated</div>
              <div className="col-md-7">
                <DateText date={this.props.account.updatedAt}/>
              </div>
              </div>
              <div className="row details-row">
                <div className="col-md-5 details-label">Status</div>
                <div className="col-md-7">
                  {this.props.account.isActive ? "Active" : "Inactive"}
                </div>
              </div>
            </div>
          </div>
          <AccountContact
              isVisible={this.state.isEditContactVisible}
              contact={this.props.account.contact}
              hideHandler={() => {
                this.setState({isEditContactVisible: false})
              }}
              editHandler={this.handleContactChange}
          />
        </div>
    );
  }
}

export default AccountHeader;



// WEBPACK FOOTER //
// ./src/accounts/account-details/components/AccountHeader.js